import {Component} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-core-page-hashtag-create',
    templateUrl: './page-hashtag-create.component.html',
    styleUrls: ['./page-hashtag-create.component.scss'],
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageHashtagCreateComponent {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Create);
    }
}
